export default "__VITE_ASSET__SvUHPTHd__"